import React, { useEffect, useState } from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import { apiGet } from '../API/Api_Url';

function TermsandConditions() {

  const [Termsandcondition, setTermsandcondition] = useState('');
  const [IsUploading, setIsUploading] = useState(false);
  const GetTermsandcondition = async () => {
    try {
      setIsUploading(true);
      const response = await apiGet('api/admin/GetTermsandcondition');
      setTermsandcondition(response?.data?.Termsandcondition);
      setIsUploading(false);
    } catch (error) {
      setIsUploading(false);
      console.error('Error fetching data:', error);
    }
  }

  useEffect(() => {
    GetTermsandcondition()
  }, []);


  const Loader = () => (
    <div className="flex justify-center items-center h-[100vh]">
      <div className="w-10 h-10 border-4 border-gray-300 border-t-blue-600 rounded-full animate-spin"></div>
    </div>
  );


  return (
    <>
      <Navbar />
      {IsUploading ?
        <>
          <Loader />
        </>
        :
        <>
          <div className='Terms-banner'>
            <h3>Terms & Conditions</h3>
            <p>Post your construction or renovation requirements and get connected with our network of Professionals.</p>


          </div>
          <div className='terms'>
            <div
              dangerouslySetInnerHTML={{ __html: Termsandcondition }}
              style={{ color: 'black', fontSize: '14px', lineHeight: '1.6' }}
            >
            </div>
          </div>
        </>
      }
      <Footer />
    </>
  )
}

export default TermsandConditions